const initialState = {
  message: "",
};
const SaveMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SAVE_MESSAGE":
      return (initialState.message = action.payload);
    default:
      return state;
  }
};

export default SaveMessageReducer;
